import React from "react";
import { Select } from "antd";

import { trb } from "@utilities";

const Option = Select.Option;

export const SelectOnlyFormField = ({
  size,
  placeholder,
  disabled,
  options,
  optionsLabel,
  optionsDisabled,
  optionsValue,
  translate,
  optionsLabelImg,
  meta,
  input,
}) => {
  const checkOption = (value, input) => {
    if (!options) {
      return null;
    }

    const optionValue = options.find(e => e[optionsValue] === value);

    if (optionValue) {
      return value;
    } else {
      input.onChange(undefined);
    }
  };

  return (
    <>
      <Select
        allowClear
        placeholder={trb(placeholder)}
        disabled={disabled}
        name={input.name}
        value={checkOption(input.value, input)}
        onChange={input.onChange}
        getPopupContainer={() => document.getElementById("card")}
        size={size}
      >
        {options &&
          options.map((item, index) => (
            <Option
              className={optionsLabelImg ? "text-center" : null}
              disabled={item[optionsDisabled]}
              value={item[optionsValue]}
              key={index}
            >
              {optionsLabelImg ? (
                <>
                  <img
                    src={item[optionsLabel]}
                    style={{ borderRadius: "100%", height: 16, width: 16 }}
                  />
                </>
              ) : (
                <>{translate ? trb(translate + item[optionsLabel]) : item[optionsLabel]}</>
              )}
            </Option>
          ))}
      </Select>
      <div
        style={{ top: 47, zIndex: 1, direction: "rtl" }}
        className={"position-absolute form-field-error col-12 pr-1"}
      >
        {meta.touched && (meta.error || meta.submitError)}
      </div>
    </>
  );
};
